import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Images } from "../../../assests";
import { useNavigate, useParams } from "react-router-dom";
import OrderServices from "../../../services/OrderServices";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Helmet } from "react-helmet";
import Colors from "../../../assests/style";

const BlogDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // ✅ get blog id from URL
  const [blogDetail, setBlogDetail] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const getBlogDetail = async () => {
    try {
      setLoading(true);
      let params={
        id:id
      }
      const data = await OrderServices.getBlogDetail(params);
      setBlogDetail(data?.data?.blog || {});
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blog detail:", error);
      setLoading(false);
    }
  };

  const getRelatedBlogs = async () => {
    try {
      const data = await OrderServices.getBlogs({ page: 1, limit: 4 });
      setRelatedBlogs(data?.data?.blogs || []);
    } catch (error) {
      console.error("Error fetching related blogs:", error);
    }
  };

  useEffect(() => {
    getBlogDetail();
    getRelatedBlogs();
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div>
      <Helmet>
        <title>{blogDetail?.title || "Blog Detail | Print Me Up"}</title>
        <meta
          name="description"
          content={blogDetail?.short_description || "Explore our latest blog post!"}
        />
        <link rel="canonical" href={`https://pk.printmeup.ai/blog/${id}`} />
      </Helmet>

      {/* Banner Section */}
      <Box
        sx={{
          backgroundImage: `url("${Images.contactBg}")`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          width: "100%",
          height: { lg: "300px", md: "300px", sm: "220px", xs: "220px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Box
          component="p"
          className="banner-text heading-font"
          sx={{
            fontSize: { lg: "52px", md: "52px", sm: "40px", xs: "30px" },
            textAlign: "center",
            fontFamily: "Noto Sans, sans-serif",
          }}
        >
          Blog Detail
        </Box>
      </Box>

      {/* Blog Detail Content */}
      <Box
        sx={{
          py: 8,
          background: "linear-gradient(180deg, #0C1427 0%, #101B35 100%)",
        }}
      >
       <Grid container justifyContent="center">
  <Grid item md={9.5} sm={11} xs={11}>
    {loading ? (
      <Typography
        sx={{
          textAlign: "center",
          color: "white",
          py: 6,
          fontSize: "18px",
        }}
      >
        Loading blog detail...
      </Typography>
    ) : (
      blogDetail && (
        <Box
          sx={{
            background: "#0F172A",
            borderRadius: "16px",
            boxShadow:
              "0 4px 20px rgba(11,193,217,0.2), inset 0 0 10px rgba(11,193,217,0.1)",
            overflow: "hidden",
            p: { xs: 2, sm: 4 },
          }}
        >
          <Grid container spacing={4} >
            {/* Left side - Image */}
            <Grid item xs={12} md={5}>
              <CardMedia
                component="img"
                image={blogDetail?.image || Images.placeholder}
                alt={blogDetail?.title}
                sx={{
                  width: "100%",
                  height: { xs: 250, md: 400 },
                  objectFit: "cover",
                  borderRadius: "12px",
                }}
              />
            </Grid>

            {/* Right side - Content */}
        <Grid item xs={12} md={7}>
  {/* Title and Date Row */}
  <Box
    sx={{
      display: "flex",
      justifyContent: { xs: "center", md: "space-between" },
      alignItems: "center",
      flexWrap: "wrap",
      mb: 2,
      textAlign: { xs: "center", md: "left" },
    }}
  >
    <Typography
      variant="h4"
      sx={{
        color: "#0bc1d9",
        fontWeight: "bold",
        mb: { xs: 1, md: 0 },
      }}
    >
      {blogDetail?.title}
    </Typography>

    <Typography
      variant="body2"
      sx={{
        color: "rgba(255,255,255,0.6)",
        fontStyle: "italic",
      }}
    >
      {new Date(blogDetail?.createdAt).toLocaleDateString()}
    </Typography>
  </Box>

  {/* Short Description */}
  {blogDetail?.short_description && (
    <Typography
      variant="subtitle1"
      sx={{
        color: "rgba(255,255,255,0.75)",
        mb: 3,
        fontWeight: 500,
        textAlign: { xs: "center", md: "left" },
      }}
    >
      {blogDetail?.short_description}
    </Typography>
  )}

  {/* Full Content */}
  <Typography
    variant="body1"
    sx={{
      color: "rgba(255,255,255,0.85)",
      lineHeight: 1.8,
      whiteSpace: "pre-line",
      textAlign: { xs: "center", md: "left" },
    }}
    dangerouslySetInnerHTML={{
      __html: blogDetail?.content || "",
    }}
  />
</Grid>

          </Grid>
        </Box>
      )
    )}
  </Grid>
</Grid>

      </Box>

      {/* Related Blogs Section */}
      <Box
        sx={{
          p: 8,
        
        }}
      >
          <Grid container justifyContent="center">
        <Typography
          variant="h4"
          sx={{
            color: "#0bc1d9",
            fontWeight: "bold",
            textAlign: "center",
            mb: 4,
          }}
        >
          Related Blogs
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {relatedBlogs.map((blog, index) => (
            <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
              <Card
                sx={{
                  background: "#0F172A",
                  color: "white",
                  borderRadius: "16px",
                  boxShadow:
                    "0 4px 15px rgba(11,193,217,0.15), inset 0 0 10px rgba(11,193,217,0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow:
                      "0 8px 25px rgba(11,193,217,0.35), inset 0 0 15px rgba(11,193,217,0.2)",
                  },
                }}
              >
                <CardActionArea onClick={() => navigate(`/blog/${blog._id}`)}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={blog?.image || Images.placeholder}
                    alt={blog?.title}
                    sx={{
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                      objectFit: "cover",
                    }}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h6"
                      sx={{
                        color: "#0bc1d9",
                        fontWeight: "bold",
                        mb: 1,
                        minHeight: "50px",
                      }}
                    >
                      {blog?.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "rgba(255,255,255,0.8)",
                        mb: 2,
                        height: "60px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {blog?.short_description ||
                        blog?.description?.slice(0, 120) + "..."}
                    </Typography>
                    <Button
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        background: "#0bc1d9",
                        color: "#0C1427",
                        fontWeight: "bold",
                        textTransform: "none",
                        borderRadius: "8px",
                        px: 2,
                        py: 1,
                        "&:hover": {
                          background: "#09a7c0",
                        },
                      }}
                      onClick={() => navigate(`/blog/${blog._id}`)}
                    >
                      Read More
                    </Button>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default BlogDetail;
